function clickDownload(link) {
        window.location.href = link;
    }

    // new WheelCarousel('introduction5-sticky-box', 'introduction5-sticky', 'introduction5-wheel-carousel',0.2)

    new Swiper("#introduction5-swiper-mobile", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        touchRatio:1.5,
        centeredSlides : true,
        pagination: {
            el: '#introduction5-swiper-pagination-mobile',
            renderBullet: function (index, className) {
                return '<span class="' + className + '"> </span>';
            },
        },
        on: {

        },
    });

    new Swiper("#introduction5-swiper", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        touchRatio:1.5,

        pagination: {
            el: '#introduction5-swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"> </span>';
            },
        },
        navigation: {
            nextEl: '#introduction5-swiper-next-btn',
            prevEl: '#introduction5-swiper-prev-btn',
        },
        on: {

        },
    });

    setSwiperContentHeight('introduction-h1-mobile')
    setSwiperContentHeight('introduction-h2-mobile')

    $(window).on('resize', function () {
        setSwiperContentHeight('introduction-h1-mobile')
        setSwiperContentHeight('introduction-h2-mobile')
    })
